export default "__VITE_ASSET__DkDIxl0b__"